// NODE ACTIONS.
export const SET_NODES = 'SET_NODES';
export const UPDATE_NODE = 'UPDATE_NODE';
export const REMOVE_NODE = 'REMOVE_NODE';
export const UPDATE_NODE_POSITION = 'UPDATE_NODE_POSITION';
export const ADD_ACTION_CLICKED = 'ADD_ACTION_CLICKED';
// FLOW ACTIONS.
export const FLOW_DELETE_LOCAL_SUCCEEDED = 'FLOW_DELETE_LOCAL_SUCCEEDED';
export const FLUSH = 'FLUSH';
export const UNSAVED_CHANGES = 'UNSAVED_CHANGES';
export const FLOW_FETCH = 'FLOW_FETCH';
export const FLOW_FETCH_SUCCEEDED = 'FLOW_FETCH_SUCCEEDED';
export const FLOW_FETCH_FAILED = 'FLOW_FETCH_FAILED';
export const UNSAVED_FLOW_SAVED = 'UNSAVED_FLOW_SAVED';
export const FLOW_ADD_AFTER_BUY_NUMBER = 'FLOW_ADD_AFTER_BUY_NUMBER';
export const FLOW_ADD_AFTER_BUY_NUMBER_SUCCEEDED = 'FLOW_ADD_AFTER_BUY_NUMBER_SUCCEEDED';
export const FLOW_ADD_AFTER_BUY_NUMBER_FAILED = 'FLOW_ADD_AFTER_BUY_NUMBER_FAILED';
export const FLOW_UPDATE = 'FLOW_UPDATE';
export const FLOW_UPDATE_SUCCEEDED = 'FLOW_UPDATE_SUCCEEDED';
export const FLOW_UPDATE_FAILED = 'FLOW_UPDATE_FAILED';
export const CHANGE_NUMBER = 'CHANGE_NUMBER';
export const CHANGE_NAME = 'CHANGE_NAME';
export const CHANGE_ACTIVE = 'CHANGE_ACTIVE';
export const CHANGE_STATUS = 'CHANGE_STATUS';
